<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Synonyme bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.synonyms.update', synonym))">
                <form-fields :form="form" :synonym="synonym" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'synonym',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    terms: this.synonym.terms,
                    notes: this.synonym.notes,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>